module.exports = __webpack_public_path__ + "static/media/lemon.41192ad4.svg";